import { useMemo } from 'react';
import { useTableBaseInputProps } from './baseInputProps';
import typesOfChoices from '../../../../constants/typesOfChoices';

/**
 *
 * @param { string } name - имя поля
 * @param { Object } data - Данные
 * @param { Object } fields - Поля
 * @param { Object } errors - Ошибки
 * @param { function } onChange - handler
 * @param { number } rowIndex - rowIndex
 * @param { boolean } isReadOnly - isReadOnly
 * @param {string[]} readOnlyFelds - readOnlyFelds
 * @param { array } filter - фільтр
 * @returns {{
 *  onChange: (function(*, *): *),
 *  description: string,
 *  readOnly: boolean,
 *  controlId: string,
 *  value: Object,
 *  required: boolean,
 *  errors: Array,
 *  backend: string,
 *  }}
 */

export const useItemInputProps = (
  name,
  data,
  fields,
  errors,
  onChange,
  rowIndex,
  isReadOnly = false,
  readOnlyFelds = [],
) => {
  const baseProps = useTableBaseInputProps(
    name,
    data,
    fields,
    errors,
    onChange,
    rowIndex,
    isReadOnly,
    readOnlyFelds,
  );
  const backend = useMemo(
    () => (fields && fields[name] ? fields[name].resource : null),
    [fields, name],
  );
  const typeOfChoice = useMemo(
    () => {
      if (!fields || !fields[name] || !fields[name].selection_mode) return null;
      switch (fields[name].selection_mode) {
        case 'items':
          return typesOfChoices.onlyElements;
        case 'folders':
          return typesOfChoices.onlyGroups;
        case 'all':
          return typesOfChoices.groupsEndElements;
        default:
          return null;
      }
    },
    [fields, name],
  );
  return useMemo(
    () => ({
      ...baseProps,
      backend,
      ...(typeOfChoice !== null ? { typeOfChoice } : {}),
      canErase: !baseProps.required,
    }),
    [backend, baseProps, typeOfChoice],
  );
};

export default useItemInputProps;
